import { render, staticRenderFns } from "./musicMetaData.vue?vue&type=template&id=8809747a&scoped=true"
import script from "./musicMetaData.vue?vue&type=script&lang=js"
export * from "./musicMetaData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8809747a",
  null
  
)

export default component.exports